import { render, staticRenderFns } from "./SettleComplete.vue?vue&type=template&id=22732bbf&scoped=true&"
import script from "./SettleComplete.vue?vue&type=script&lang=ts&"
export * from "./SettleComplete.vue?vue&type=script&lang=ts&"
import style0 from "./SettleComplete.vue?vue&type=style&index=0&id=22732bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22732bbf",
  null
  
)

export default component.exports